(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
$(function() {
  var $container = $('#cart__buttons-container');
  var $check = $('#cart__submitCheckInput');
  var $submit = $('#cart__submitCheckout');

  if (!$check[0]) {
    return;
  }

  $container.addClass('-is-disabled');
  $submit.prop('disabled', true);

  $check.on('change', function () {
    if ($check.is(':checked')) {
      $container.removeClass('-is-disabled');
      $submit.prop('disabled', false);
    } else {
      $container.addClass('-is-disabled');
      $submit.prop('disabled', true);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
